<template>
  <div id="extended-container">
    <nav class="blue-grey darken-3">
      <img
        class="logo"
        src="../assets/logo-dpsm.png"
      >
      <div class="right">
        <span
          v-if="user"
          class="current-user"
        >
          {{ user.prenom }} {{ user.nom }} ({{ user.utam }})
        </span>
      </div>
    </nav>
    <div>
      <ul class="sidenav sidenav-fixed blue-grey lighten-4">
        <li class="logo-container center-left">
          <a 
            href="#"
            id="desktop-nav-toggle"
            :class="windowWidth < 1350 ? 'nav-collapsed' : ''"
            @click="toggleNav($event)"
          >
            <span class="visually-hidden">
              Expand / Collapse menu
            </span>
          </a>
        </li>
        <li title="Accueil">
          <router-link
            to="/"
            class="waves-effect"
          >
            <font-awesome-icon icon="home" fixed-width />
          </router-link>
        </li>
        <li
          title="Assistants de saisie (ASIS)"
          class="no-padding"
          v-if="hasRole('Utilisateur collecte DPSM')"
        >
          <router-link
            to="/asis"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="file-signature" fixed-width />
          </router-link>
        </li>
        <li
          v-if="hasRole('Utilisateur collecte DPSM') || hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')"
          title="Formulaires de saisie"
          class="no-padding"
        >
          <router-link
            v-if="hasRole('Utilisateur collecte DPSM')"
            to="/listfsd"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="folder-open" fixed-width />
          </router-link>
          <router-link
            v-else
            to="/submitfsd"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="envelope" fixed-width />
          </router-link>
        </li>
        <li
          v-if="hasRole('Utilisateur collecte DPSM')"
          title="Historique des versements"
          class="no-padding"
        >
          <router-link
            to="/versements"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="list-ul" fixed-width />
          </router-link>
        </li>
        <li
          v-if="hasRole('Utilisateur collecte DPSM')"
          title="Appareils de mesure"
          class="no-padding"
        >
          <router-link
            to="/materiel"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="tachometer-alt" fixed-width />
          </router-link>
        </li>
        <li
          v-if="hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')"
          title="Acquisitions périodiques"
          class="no-padding"
        >
          <router-link
            to="/acquisition"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="list-ul" fixed-width />
          </router-link>
        </li>
        <li v-if="(this.accesDonneesAutres) || !this.isOnlyLecteur"
          title="Afficher les données"
          class="no-padding active"
        >
          <router-link
            to="/surveillance"
            class="collapsible-header waves-effect"
          >
            <font-awesome-icon icon="fa fa-chart-column" fixed-width />
          </router-link>
        </li>
        <li v-if="(this.accesDonneesTopos) || !this.isOnlyLecteur"
          title="Afficher les données topo"
          class="no-padding"
        >
          <router-link
            to="/surveillanceTopo"
            class="waves-effect"
          >
            <font-awesome-icon icon="fa fa-chart-line" fixed-width />
          </router-link>
        </li>
        <li
          v-if="hasRole('Utilisateur collecte DPSM') || hasRole('Administrateur collecte DPSM') || hasRole('Administrateur DPSM')"
          title="Créer des rapports"
          class="no-padding"
        >
          <router-link
            to="/rapports"
            class="waves-effect"
          >
            <font-awesome-icon icon="fa fa-file-excel" fixed-width />
          </router-link>
        </li>
        <li>
          <div class="divider blue-grey lighten-3" />
        </li>
        <li title="Déconnexion">
          <a
            class="waves-effect"
            @click="logout"
            href="#!"
            id="btn-deconnexion"
          >
            <font-awesome-icon icon="power-off" fixed-width />
            Déconnexion
          </a>
        </li>
        <li class="version-number">
          {{ version }}
        </li>
      </ul>
    </div>
    <div
      id="main-content"
      :class="windowWidth < 1350 ? 'nav-collapsed' : ''"
    >
      <div
        id="slide-out"
        class="sidenav-menu blue-grey lighten-5"
      >
        <ExtendedSurveillance
            :infosLecteur="this.lecteurDonneesSurveillance"
        />
      </div>
      <div id="slot-container">
        <slot />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { rolesHelper } from '../helpers'
import ExtendedSurveillance from './components/ExtendedSurveillance.vue'
import { utilisateursService } from '../services'

export default {
    components: {
        ExtendedSurveillance
    },
    data: function () {
        return {
            windowWidth: null,
            lecteurDonneesSurveillance: null,
            isOnlyLecteur: false,
            accesDonneesTopos: false,
            accesDonneesAutres: false
        }
    },
    emits: ['reset-utam-surv'],
    computed: {
        ...mapGetters('authentication', [
            'token',
            'user'
        ]),
        version: function () {
            return process.env.VUE_APP_VERSION
        }
    },
    watch: {
        lecteurDonneesSurveillance() {
            this.lecteurDonneesSurveillance.forEach(role => {
                if (role.isLecteur && role.accesDonneesTopos) {
                    this.accesDonneesTopos = true
                }

                if (role.isLecteur && role.accesDonneesAutres) {
                    this.accesDonneesAutres = true
                }
            })
        } 
    },
    methods: {
        hasRole: function (role) {
            return rolesHelper.hasRole(role)
        },
        logout: function () {
            this.eventBus.emit('reset-utam-surv')
            this.$store.dispatch('authentication/logout')
        },
        toggleNav: function (event) {
            event.preventDefault()
            let arrowtoggle = document.querySelector('#desktop-nav-toggle')
            let container = document.querySelector('#main-content')

            if (container.classList.contains('nav-collapsed')) {
                container.classList.remove('nav-collapsed')
                arrowtoggle.classList.remove('nav-collapsed')
            } else {
                container.classList.add('nav-collapsed')
                arrowtoggle.classList.add('nav-collapsed')
            }
        },
        resetCollapsedState: function () {
            let arrowtoggle = document.querySelector('#desktop-nav-toggle')
            let container = document.querySelector('#main-content')
            container.classList.remove('nav-collapsed')
            arrowtoggle.classList.remove('nav-collapsed')
        }
    },
    mounted () {
        this.windowWidth = window.innerWidth
        var _this = this
        document.body.addEventListener('click', function (e) {
            if (window.innerWidth <= 1350) {
                var navToggler = document.getElementById('desktop-nav-toggle')
                var navMenu = document.getElementById('slide-out')
                if (!navMenu.contains(e.target) && !navToggler.contains(e.target) && !document.getElementById('main-content').classList.contains('nav-collapsed')) {
                    _this.toggleNav(e)
                }
            }
        })

        // On récupère les infos de rôles de l'utilisateur (rôle lecteur)
        const user = localStorage.getItem('user')

        if (user && user != undefined) {
            const userId = JSON.parse(user).id

            let lecteurDonneesSurveillance = utilisateursService.getInfosLecteurSurveillance(userId).then(data => {
                if (data && data.length > 0) {
                    this.lecteurDonneesSurveillance = data
                    this.isOnlyLecteur = data[0].isOnlyLecteur // Cette valeur est identique pour tous les rôles lecteurs de l'utilisateur normalement
                }
            })
        }     
    },
    updated() {
        
    }
}
</script>
<style scoped>
.logo {
    width: 200px;
}

.visually-hidden{
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    overflow: hidden;
}

#extended-container{
    padding-left: 95px;
    transition: .2s padding-left;
}

nav{
    padding-left: 10px;
    padding-right: 10px;
}

.sidenav{
    width: 95px;
    box-shadow: none;
}

.sidenav li.logo-container{
    position: relative;
}

.sidenav li > a{
    text-align: center;
}

.sidenav li.active > a {
    background-color: #eceff1 !important
}

.sidenav a svg{
    margin-right: 0px;
    width: 1.2rem;
    height: 1.2rem;
}

.sidenav .collapsible-header, .sidenav.fixed .collapsible-header {
    padding: 0 32px;
}

#desktop-nav-toggle{
    height: 75px;
    /* display: inline-block; */
}

#desktop-nav-toggle:before{
    content: "\00bb";
    position: absolute;
    top: calc(50% - 0.06em);
    left: 50%;
    transform: translate(-50%, -50%);
    color: gray;
    font-size: 4.2em;
}

#desktop-nav-toggle > p{
    font-size: 4.0rem;
    margin: 0;
    padding-top: 0.5rem;
}

#desktop-nav-toggle > p.nav-collapsed{
    transform: rotate(180deg);
    padding-bottom: 0.5rem;
    padding-top: 0;
}

#desktop-nav-toggle.nav-collapsed:before{
    top: calc(50% + 0.06em);
    transform: translate(-50%, -50%) rotate(180deg);
}

.version-number{
    bottom: 55px;
    color: #a5a5a5;
    margin-left: 10px;
    font-size: 0.8em;
    text-transform: uppercase;
}
.version-number::before{
    content: "V"
}

#main-content{
    display: flex;
    padding: 0;
}

.sidenav-menu{
    height: calc(100vh - 75px);
    /*height: 100vh;*/
    width: 400px;
    position: sticky;
    top: 0;
    overflow-y: auto;
    z-index: 3;
}
.sidenav-menu.modalOpen{
    z-index: 0;
}

.sidenav-menu{
    scrollbar-width: thin;
}
.sidenav-menu::-webkit-scrollbar {
    width: 10px;
    background-color: lightgray;
}
.sidenav-menu::-webkit-scrollbar-thumb {
    border: 2px solid lightgray;
    background-color: #ffffff;
    border-radius: 10px;
}

#main-content > div:last-child{
    width: calc(100% - 400px);
    height: calc(100vh - 75px);
    overflow-y: scroll;
    padding: 10px;
    padding-left: 30px;
    padding-right: 30px;
}

#main-content div{
    transition: .2s width;
}

#main-content.nav-collapsed div:last-child{
    width: 100%;
}
#main-content.nav-collapsed .sidenav-menu{
    width: 0%;
}

@media screen and (max-width: 1350px){
    .sidenav.sidenav-fixed{
        transform: translateX(0)!important;
    }
    .sidenav-menu{
        position: fixed;
        z-index: 3;
    }
    #main-content > div:last-child{
        width: 100%;
    }
}

@media only screen and (min-width: 601px){
    nav{
        height: 75px;
    }
}
</style>
